export default "__VITE_ASSET__Xv0tqh5S__"